import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormLabelComponent } from '../form-label/form-label.component';

export interface RadioButtonOptions {
    id: string;
    label: string;
    value: any;
    disabled?: boolean;
}

@Component({
    selector: 'radio-button',
    standalone: true,
    imports: [RadioButtonModule, TranslateModule, FormsModule, FormLabelComponent],
    templateUrl: './radio-button.component.html',
    styleUrl: './radio-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
    name = input.required<string>();
    model = model.required<any>();
    options = input.required<RadioButtonOptions[]>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);

    disabled = input<boolean>(false);
    inline = input<boolean>(true);
    invalid = input<boolean>(false);
}
